/** Campos — Reporte de evolución (Informe de avance) TO ocupacional */

export const TIPO_CAMPO = {
  LINEA: "linea",
  MULTILINEA: "multilinea",
  FECHA: "fecha",
};

export const CAMPOS_DATOS_GENERALES = [
  { key: "nombreApellido", label: "Nombre y apellido", tipo: TIPO_CAMPO.LINEA, maxLength: 80 },
  { key: "fnacimiento", label: "Fecha de nacimiento", tipo: TIPO_CAMPO.FECHA },
  { key: "edadTexto", label: "Edad", tipo: TIPO_CAMPO.LINEA, maxLength: 25 },
  { key: "diagnostico", label: "Diagnóstico", tipo: TIPO_CAMPO.LINEA, maxLength: 100 },
  { key: "nombreTerapeuta", label: "Terapeuta", tipo: TIPO_CAMPO.LINEA, maxLength: 80 },
  { key: "fechaInforme", label: "Fecha", tipo: TIPO_CAMPO.FECHA },
];

export const CAMPOS_CONTEXTO = [
  { key: "areasFinalidad", label: "Áreas del reporte", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
  { key: "vecesPorSemana", label: "Veces por semana en la fundación", tipo: TIPO_CAMPO.LINEA, maxLength: 10 },
  { key: "diasTerapiaTexto", label: "Días de terapia", tipo: TIPO_CAMPO.LINEA, maxLength: 80 },
  { key: "horarioDesde", label: "Horario desde", tipo: TIPO_CAMPO.LINEA, maxLength: 20 },
  { key: "horarioHasta", label: "Horario hasta", tipo: TIPO_CAMPO.LINEA, maxLength: 20 },
  { key: "asistencia", label: "Asistencia", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
];

export const CAMPOS_EVOLUCION = [
  { key: "evolucionIntro", label: "Evolución terapéutica (introducción)", rows: 4 },
  { key: "regulacion", label: "A nivel de regulación", rows: 4 },
  { key: "atencion", label: "En el área de atención", rows: 4 },
  { key: "motor", label: "A nivel motor", rows: 4 },
  { key: "procesamientoSensorial", label: "Procesamiento sensorial", rows: 4 },
  { key: "conductual", label: "En el aspecto conductual", rows: 4 },
];

export const CAMPOS_CIERRE = [
  { key: "conclusion", label: "Conclusión", rows: 5 },
  { key: "objetivosTerapeuticos", label: "Objetivos terapéuticos", rows: 5 },
  { key: "recomendaciones", label: "Recomendaciones", rows: 5 },
];
